export enum StatusType {
	Default = 'Default',
	Inactive = 'Inactive',
	Success = 'Success',
	Error = 'Error',
	Warning = 'Warning',
	Pending = 'Pending',
}
